export const ERROR_TYPES = {
  HTTP_ERROR: 'http-error',
  NOT_FOUND: 'not-found',
  REDUX_SELECT_WHEN: 'redux-select-when',
  UNKNOWN: 'unknown',
};
